import Vue from 'vue';

import {
  price,
  lowercase,
  capitalize,
  productName
} from '@nespresso/vue-core/filters';

export const registerFilters = () => {
  Vue.filter('price', price);
  Vue.filter('lowercase', lowercase);
  Vue.filter('capitalize', capitalize);
  Vue.filter('productName', productName);
};
